import React, { useState } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";

export default function MainLayout({ userRole }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const usuario = JSON.parse(localStorage.getItem("usuario"));

  const logout = () => {
    localStorage.removeItem("usuario");
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");

    window.location.replace("/");
  };

  const closeSidebar = () => setOpen(false);

  const active = (path) =>
    location.pathname === path ? "bg-cream/95 text-moss font-semibold" : "";

  const homeRoute =
    usuario?.role === "admin"
      ? "/backoffice-dashboard"
      : usuario?.role === "cliente"
      ? "/dashboard-cliente"
      : "/dashboard-comprador";

  return (
    <div className="flex h-screen">

      <aside
        className={`${open ? "w-64" : "w-0 md:w-64"
          } bg-ink text-cream shadow-2xl shadow-black/30 transition-all duration-300 overflow-hidden`}
      >
        {/* Logo */}
        <div className="p-4 border-b border-white/10 flex items-center justify-between">
          <Link
            to={homeRoute}
            onClick={closeSidebar}
            className="text-xl font-bold text-cream hover:text-gold transition-opacity cursor-pointer"
          >
            OfferApp
          </Link>

          <button
            className="md:hidden p-2 text-cream/70"
            onClick={() => setOpen(false)}
          >
            ✕
          </button>
        </div>

        {/* Mini Perfil */}
        <div className="p-4 border-b border-white/10">
          <p className="font-semibold">{usuario?.nombre}</p>
          <p className="text-sm text-cream/55 capitalize">
            Rol: {usuario?.role}
          </p>
        </div>

        {/* ============ MENÚ ============ */}
        <nav className="p-4 space-y-2 text-sm">

          {/* Admin Panel - Solo para admin */}
          {usuario?.role === "admin" && (
            <>
              <Link
                to="/backoffice-dashboard"
                onClick={closeSidebar}
                className={`block p-2 rounded-lg hover:bg-white/10 ${active("/backoffice-dashboard")}`}
              >
                📈 Dashboard
              </Link>
              <Link
                to="/admin"
                onClick={closeSidebar}
                className={`block p-2 rounded-lg hover:bg-white/10 ${active("/admin")}`}
              >
                👤 Crear Usuario
              </Link>
              <Link
                to="/backoffice"
                onClick={closeSidebar}
                className={`block p-2 rounded-lg hover:bg-white/10 ${active("/backoffice")}`}
              >
                📄 Backoffice Facturas
              </Link>
            </>
          )}

          {/* Inicio - Para clientes y compradores (no admin) */}
          {usuario?.role !== "admin" && (
            <Link
              to={usuario?.role === "cliente" ? "/dashboard-cliente" : "/dashboard-comprador"}
              onClick={closeSidebar}
              className={`block p-2 rounded-lg hover:bg-white/10 ${active(usuario?.role === "cliente" ? "/dashboard-cliente" : "/dashboard-comprador")}`}
            >
              🏠 Inicio
            </Link>
          )}


          {/* Publicaciones */}
          {usuario?.role === "cliente" && (
            <Link
              to="/publicaciones-cliente"
              onClick={closeSidebar}
              className={`block p-2 rounded-lg hover:bg-white/10 ${active("/publicaciones-cliente")}`}
            >
              📄 Mis publicaciones
            </Link>
          )}

          {usuario?.role === "comprador" && (
            <Link
              to="/publicaciones-comprador"
              onClick={closeSidebar}
              className={`block p-2 rounded-lg hover:bg-white/10 ${active("/publicaciones-comprador")}`}
            >
              📄 Publicaciones disponibles
            </Link>
          )}

          {/* Ofertas */}
          {usuario?.role === "cliente" && (
            <Link
              to="/ofertas-recibidas"
              onClick={closeSidebar}
              className={`block p-2 rounded-lg hover:bg-white/10 ${active("/ofertas-recibidas")}`}
            >
              💰 Ofertas recibidas
            </Link>
          )}

          {/* Bloqueos */}
          {usuario?.role === "cliente" && (
            <Link
              to="/bloqueos"
              onClick={closeSidebar}
              className={`block p-2 rounded-lg hover:bg-white/10 ${active("/bloqueos")}`}
            >
              🚫 Compradores bloqueados
            </Link>
          )}

          {/* Movimientos */}
          <Link
            to="/movimientos"
            onClick={closeSidebar}
            className={`block p-2 rounded-lg hover:bg-white/10 ${active("/movimientos")}`}
          >
            📊 Movimientos
          </Link>

          {/* Notificaciones */}
          <Link
            to="/notificaciones"
            onClick={closeSidebar}
            className={`block p-2 rounded-lg hover:bg-white/10 ${active("/notificaciones")}`}
          >
            🔔 Notificaciones
          </Link>

          {/* Perfil */}
          <Link
            to="/perfil"
            onClick={closeSidebar}
            className={`block p-2 rounded-lg hover:bg-white/10 ${active("/perfil")}`}
          >
            👤 Mi perfil
          </Link>

          {/* Logout */}
          <button
            onClick={logout}
            className="w-full text-left p-2 rounded-lg bg-cream/10 text-cream mt-3 hover:bg-red-900/40"
          >
            🚪 Cerrar sesión
          </button>
        </nav>
      </aside>

      <div className="flex-1 flex flex-col overflow-hidden">

        {/* Topbar */}
        <header className="h-14 bg-cream/75 backdrop-blur border-b border-white/40 shadow-sm flex items-center justify-between px-4">

          <button
            className="md:hidden p-2 text-ink"
            onClick={() => setOpen(true)}
          >
            ☰
          </button>


          <Link
            to={homeRoute}
            className="font-semibold text-primary hover:text-moss transition-opacity cursor-pointer"
          >
            Plataforma de Factoring
          </Link>

          <div className="flex items-center gap-3">
            <Link
              to="/notificaciones"
              className="text-xl text-stone-700 hover:text-moss"
            >
              🔔
            </Link>

            <Link
              to="/perfil"
              className="text-xl text-stone-700 hover:text-moss"
            >
              👤
            </Link>
          </div>
        </header>

        {/* Render de páginas */}
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
